// Application hooks that run for every service
import getMerchant from '../utils/getMerchant';

const merchantCodeHook = (context) => {
  const { code } = getMerchant();
  const { params } = context;
  context.params.headers = { 'sx-merchant-code' : code, ...params.headers };
  return context;
};

export default {
  before: {
    all: [ merchantCodeHook ],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },

  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },

  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};



// WEBPACK FOOTER //
// ./src/application/client/app.hooks.js